<template>
  <div :class="['moment-cta', { 'disabled': disabled }]">
    <div class="moment-cta__wrapper">
      <p class="pl-3 pt-3">
        GBP CTA button (optional)
      </p>

      <hr class="moment-cta__separator">

      <div class="moment-cta__filters">
        <div class="moment-cta__fields">
          <CustomSelect
            v-model="typesCtaButton"
            class="moment-cta__field"
            label="Button type"
            placeholder="Select a button type"
            :disabled="disabled"
            :allow-empty="true"
            @input="handleCtaChange"
            :values="typesOptions" />
          <div v-show="!['action_type_unspecified', 'call'].includes(typesCtaButton)" class="form-field moment-cta__field">
            <label class="mb-0" for="cta_link">
              Button link<span class="text-danger">*</span>
            </label>
            <input
              type="text"
              v-model="typesCtaLink"
              :disabled="disabled"
              id="cta_link"
              class="moment-cta__field"
              placeholder="Add a link to the button"
              @input="handleCtaLinkChange">
          </div>
        </div>
        <div v-if="disabled && checkin.publishedAt" class="moment-cta__fields">
          <p class="m-0">CTA button type and link can be edited on the post's page</p>
          <a v-if="checkin.localPostObfuscatedId" :href="localPostUrl(checkin)">
            <i class="far fa-link" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import CustomSelect from 'vue_widgets/components/custom_select'

export default {
  components: {
    CustomSelect
  },
  props: {
    ctaType: {
      type: String,
      required: true
    },
    ctaLink: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    checkin: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      typesCtaButton: this.ctaType || '',
      typesCtaLink: this.ctaLink || ''
    }
  },

  created() {
    this.typesOptions = [
      { text: 'Book', value: 'book' },
      { text: 'Order online', value: 'order' },
      { text: 'Buy', value: 'shop' },
      { text: 'Learn more', value: 'learn_more' },
      { text: 'Sign up', value: 'sign_up' },
      { text: 'Call now', value: 'call' }
    ]
  },

  methods: {
    handleCtaChange(value) {
      this.typesCtaButton = value === '' ? 'action_type_unspecified' : value
      this.$emit('updateCtaType', this.typesCtaButton)
      if (['action_type_unspecified', 'call'].includes(this.typesCtaButton)) {
        this.typesCtaLink = ''
        this.$emit('updateCtaLink', '')
      }
    },
    handleCtaLinkChange() {
      this.$emit('updateCtaLink', this.typesCtaLink)
    },
    localPostUrl(checkin) {
      return `/gmb/locations/${checkin.business.gmbLocationRemoteId}/local_posts/${checkin.localPostObfuscatedId}/edit`
    }
  }
}
</script>
